import { FC } from 'react';

import { ImageMedia } from '../Wrapper';
import { MediaProps } from './index';

const ImageSideMedia: FC<MediaProps> = ({ imageSideMediaUrl, title }) => (
  <ImageMedia src={imageSideMediaUrl!} alt={title} />
);

export default ImageSideMedia;
